import type { EpisodeOfCare } from "@medplum/fhirtypes";
import { EPISODE_OF_CARE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to EpisodeOfCare resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useEpisodeSubscription = createSubscriptionHook<EpisodeOfCare>(
  "EpisodeOfCare",
  EPISODE_OF_CARE_COLLECTION_NAME,
);
